/* eslint-disable no-restricted-imports */
/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { GTMAddToCartPayload } from '@/data/types/GTM';
import { findProductAttribute } from 'integration/utils/findProductAttribute';
import getValueByPathFromUnknown from 'integration/utils/getValueByPathFromUnknown';
import { getAvailableProductSizes } from 'integration/utils/getAvailableProductSizes';
import { mergeRibbonsForProduct } from '@/utils/mergeRibbonsForProduct';

// eslint-disable-next-line complexity
export const getGTMAddToCartEventData = async (payload: GTMAddToCartPayload) => {
	const { selection, quantity, storeName, orgName, orgId, category, availability, product } = payload;
	const { sku } = selection ?? {};
	const { name, partNumber, productPrice } = sku ?? {};
	const currency = productPrice?.currency ?? '';
	const hcl_account = orgId ? orgName : null;
	const marketplaceStore = storeName;
	const value = productPrice?.offer;
	const affiliation = 'Dportenis'; // This will later be the Marketplace Seller's organization name
	const list = productPrice?.list;

	const brand = findProductAttribute(sku?.attributes ?? [], 'Marca')?.value;
	const size = getValueByPathFromUnknown(selection.attrsByIdentifier, ['Talla']);
	const genre = findProductAttribute(sku?.attributes ?? [], 'Genero')?.value;
	const family = findProductAttribute(sku?.attributes ?? [], 'Familia')?.value;
	const use = findProductAttribute(sku?.attributes ?? [], 'Uso')?.value;
	const sizes = getAvailableProductSizes(product, availability);
	const ribbons = mergeRibbonsForProduct(product?.ribbons ?? []).flatMap((ribbon) => ribbon.value);
	const availableQuantity = availability?.length ? Number(availability[0].availableQuantity) : 0;
	const lowStock = (availableQuantity > 0 && availableQuantity < 15) ? 'Si' : 'No';
	const priceType = (value ?? 0) > 0 && value !== (list ?? 0) ? 'Oferta' : 'Full price';
	const color = findProductAttribute(sku?.attributes ?? [], 'Color1')?.value;

	const products = [
		{
			type: sku?.type,
			partNumber,
			name,
			quantity,
			currency,
			price: Number(productPrice?.offer),
			category: category?.identifier,
			keyword: sku?.keyword,
			affiliation,
			productPrice,
			brand,
			size,
			genre,
			family,
			use,
			sizes,
			ribbons,
			lowStock,
			priceType,
			color,
		},
	];

	return { products, currencyCode: currency, marketplaceStore, hcl_account, value };
};
